import React from 'react';
import i18next from 'i18next';
import cn from 'classnames';
import { arrayOf, bool, string, shape } from 'prop-types';

import { getColumn } from './utils';
import styles from './styles.module.scss';

function HoursContainer({ className, noDayName, noTitle, hoursArray, isLocal }) {
  return (
    <>
      {!noTitle && (
        <h6 className="m-bottom-1 text-base bold">
          {isLocal ? i18next.t('DeliveryOrPickUp:local') : i18next.t('DeliveryOrPickUp:delivery')}
        </h6>
      )}
      <div className={cn(styles.container, className)}>
        {hoursArray.map((item, index) => (
          <div
            key={item.startDay}
            className={cn('row middle', {
              [styles.columnOne]: getColumn(1, hoursArray, index),
              [styles.columnTwo]: getColumn(2, hoursArray, index)
            })}>
            {!noDayName && (
              <span className={`text-base text-dusty-gray row middle m-right-2 ${styles.dayName}`}>
                {item.endDay ? `${item.startDay} - ${item.endDay}` : item.startDay}
              </span>
            )}
            <span className="text-base text-light text-dusty-gray">{item.range}</span>
          </div>
        ))}
      </div>
    </>
  );
}

HoursContainer.propTypes = {
  className: string,
  hoursArray: arrayOf(
    shape({
      range: string,
      startDay: string,
      endDay: string
    })
  ),
  isLocal: bool,
  noDayName: bool,
  noTitle: bool
};

export default HoursContainer;
